<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog
    v-model="dialog"
    persistent
    id="support"
    width="1000px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title class="py-6">
        <div class="text-h4">{{language.t('RobotPlotter.Support.')}}</div>
      </v-card-title>
      <v-card-text class="py-6">
        <ul>
          <li v-if="language.locale == 'nl'"><a
              href="/manuals/20180330 RBP-1 Robot Plotter Snelstartgids.pdf"
              download
            >{{language.t('RobotPlotter.Support.quickstartSheet')}} (pdf)</a></li>
          <li v-if="language.locale == 'nl'"><a
              href="/manuals/4477_GA_Robot Plotter_Tyker_20210727_V2.0.pdf"
              download
            >{{language.t('RobotPlotter.Support.userManual')}} (pdf)</a></li>
          <li v-if="language.locale != 'nl'"><a
              href="/manuals/Robot_Plotter_Quick_start_guide_Tyker_20191017_(English).pdf"
              download
            >{{language.t('RobotPlotter.Support.quickstartSheet')}} (pdf)</a></li>
          <li v-if="language.locale != 'nl'"><a
              href="/manuals/4477_OI_Premarkingrobot_Tyker_20210920 (English).pdf"
              download
            >{{language.t('RobotPlotter.Support.userManual')}} (pdf)</a></li>
          <li><a
              href="https://www.tyker.com/robotplotter/"
              target="_blank"
            >{{language.t('RobotPlotter.Support.website')}}</a></li>
        </ul>
      </v-card-text>
    </v-card>

    <v-card class="mt-2">
      <v-card-title class="py-6">
        <div class="text-h4">{{language.t('RobotPlotter.Support.titleCall')}}</div>
      </v-card-title>
      <v-card-text>
        <p>{{language.t('RobotPlotter.Support.supportCall')}}</p>
        <h2>+31 (0)85 48 24 811</h2>
      </v-card-text>
      <v-card-actions class="card-actions">
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="$emit('close');"
        ><v-icon>mdi-close</v-icon>{{language.t('App.close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  components: {
  },
  props: {},
  data() {
    return {
      dialog: true
    };
  },
  mounted: function () {
    console.log(this.language);
  },
  computed: {},
  watch: {
  },
  methods: {
    onClose() {
      this.$emit("close");
    }
  },
};
</script>

<style scoped>#support {
  max-width: 1000px;
}</style>
